// extracted by mini-css-extract-plugin
export var header = "_gy-0";